export function getUsers ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/users', { params: { page: page } })
      .then((response) => {
        if (response.data.users) {
          commit('setUsers', response.data.users)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/users/' + userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}

export function getCreateUser ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/users/create')
      .then((response) => {
        if (response.data.roles) {
          commit('setRoles', response.data.roles)
          resolve(response.data)
        } else {
          if (response && response.data && response.data.message) {
            reject(response.data.message)
          }
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createUser ({ state, commit }, { name, username, email, password, confirmPassword, companyId, roles }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/users', { name, username, email, password, 'confirm-password': confirmPassword, company_id: companyId, roles })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/users/' + userId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}

/* eslint-disable-next-line */
export function editUser ({ state, commit }, { id, name, username, email, companyId, roles, password, confirmPassword }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/users/' + id, { name, username, email, password, 'confirm-password': confirmPassword, company_id: companyId, roles })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}

export function approveUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/users/' + userId + '/approve')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}

export function disapproveUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.get('/v1/users/' + userId + '/disapprove')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}

export function deleteUser ({ state, commit }, userId) {
  return new Promise((resolve, reject) => {
    if (userId) {
      axiosInstance.delete('/v1/users/' + userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No user id'))
    }
  })
}
